import service from "@/utils/request";

// 看板时间获取
export const getRange = () => {
  return service({
    url: "/api/v1/timetable/range_get",
    method: "get",
  });
};

// 看板时间设置
export interface rangeSetData {
  force: boolean;
  start_time: string;
  end_time: string;
}
export const rangeSet = (data: rangeSetData) => {
  return service({
    url: "/api/v1/timetable/range_set",
    method: "post",
    data,
  });
};

// 时间课表
export interface timeTableData {
  start_date: string;
  end_date: string;
  course_ids?: number[];
  class_ids?: number[];
  teacher_ids?: number[];
  student_ids?: number[];
  lesson_type?: number;
  roll_call_status?: number;
  course_type?: number;
  class_student_full?: number;
  student_type?: number;
  roll_call_student_status?: number;
  simplify?: boolean;
  classroom_ids?: number[];
  publish_homework?: number;
}
export const timeTable = (data: timeTableData) => {
  return service({
    url: "/api/v1/timetable",
    method: "post",
    data,
  });
};

// 教师课表
export interface teachertimeTableData {
  start_date: string;
  end_date: string;
  course_ids?: number[];
  class_ids?: number[];
  teacher_ids?: number[];
  student_ids?: number[];
  lesson_type?: number;
  roll_call_status?: number;
  course_type?: number;
  class_student_full?: number;
  classroom_ids?: number[];
  student_type?: number;
  roll_call_student_status?: number;
  publish_homework?: number;
}
export const teachertimeTable = (data: teachertimeTableData) => {
  return service({
    url: "/api/v1/timetable/teacher",
    method: "post",
    data,
  });
};

// 课次详情
export interface lessonDetailData {
  lesson_id: number;
}
export const lessonDetail = (params: lessonDetailData) => {
  return service({
    url: "/api/v1/timetable/lesson/detail",
    method: "get",
    params,
  });
};

// 教师周课表(客户端)
export interface teacherWeekListData {
  start_date: string;
  end_date: string;
}
export const teacherWeekList = (params: teacherWeekListData) => {
  return service({
    url: "/api/v1/timetable/teacher/week_list",
    method: "get",
    params,
  });
};

// 教室课表
export interface timetableClassroomInter {
  publish_homework: number;
  start_date: string;
  end_date: string;
  course_ids?: number[];
  class_ids?: number[];
  teacher_ids?: number[];
  student_ids?: number[];
  classroom_ids?: string[];
  lesson_type?: number;
  roll_call_status?: number;
  course_type?: number;
  class_student_full?: number;
  student_type?: number;
  roll_call_student_status?: number;
  lesson_exercise?: number;
}

export const timetableClassroomApi = (data: timetableClassroomInter) => {
  return service({
    url: "/api/v1/timetable/classroom",
    method: "post",
    data,
  });
};

// 课表统计
export interface timetableTotalInter {
  start_date: string;
  end_date: string;
  course_ids?: number[];
  class_ids?: number[];
  teacher_ids?: number[];
  student_ids?: number[];
  lesson_type?: number;
  roll_call_status?: number;
  course_type?: number;
  class_student_full?: number;
  student_type?: number;
  roll_call_student_status?: number;
  simplify?: boolean;
  classroom_ids?: number[];
}
export const timetableTotalApi = (data: timetableTotalInter) => {
  return service({
    url: "/api/v1/timetable/statistics",
    method: "post",
    data,
  });
};
